
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24","fill":"#5f6368"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M480-320q17 0 28.5-11.5T520-360q0-17-11.5-28.5T480-400q-17 0-28.5 11.5T440-360q0 17 11.5 28.5T480-320zm-40-160h80v-200h-80v200zm40 400q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132zm0-316z"}})])
          )
        }
      }
    